<template>
  <div
    v-show="bg.show"
    ref="sceneBg"
    class="play-scene-bg"
  >
    <div
      class="scene-bg-scale"
      :style="bgScaleStyle"
    >
      <div
        v-show="showMask"
        ref="maskDom"
        class="bg-mask-blur"
        :style="maskBlurStyle"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlaySceneBg',
  props: {
    bg: {
      type: Object,
      required: true
    },
    frame: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data(){
    return{
      type: 'Color',
      showMask: false
    };
  },
  computed: {
    bgScaleStyle(){
      const style = {};
      style.backgroundColor = this.bg.color;
      style.opacity = this.bg.opacity;
      style.transform = `scale(${this.bg.scale})`;
      return style;
    },
    maskBlurStyle() {
      const style = {};
      return style;
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.init();
    })
  },
  methods:{
    async init(){
      this.type = this.bg.type;
      if(this.type === 'Color'){
        this.showMask = false;
        this.$emit('loadDone');
        return;
      } else {
        this.showMask = true;
      }
      await this.bg.initDom(this.$refs.maskDom);
      this.$emit('loadDone');
    }
  }
};
</script>
<style lang="scss" scoped>
.play-scene-bg {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  // background-color: transparent;
  background-color: #fff;
  overflow: hidden;
}
.scene-bg-scale {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  margin: 0px auto;
  box-sizing: border-box;
  transition: transform 0s linear;
  opacity: 1;
}
</style>
<style lang="scss">
.bg-mask-blur {
  position: absolute;
  width: 1980px;
  height: 1140px;
  margin: -30px;
  box-sizing: border-box;
  background-color: transparent;
  background-image: none;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 1980px 1140px;
}
.bg-mask-blur video {
  width: 100%;
  height: 100%;
  background-color: #000;
  padding: 30px 29px;
  box-sizing: border-box;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/playSceneBg.vue